import { render } from "./MatchSessionTabs.vue?vue&type=template&id=13a2e3ba&scoped=true"
import script from "./MatchSessionTabs.vue?vue&type=script&lang=js"
export * from "./MatchSessionTabs.vue?vue&type=script&lang=js"

import "./MatchSessionTabs.vue?vue&type=style&index=0&id=13a2e3ba&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/production-allsports-2/production-as-fe-fj-SSR/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13a2e3ba"]])

export default __exports__